export default "__VITE_ASSET__BppwsvQR__"